import React from "react";

const divider = () => {
  return (
    <div
      className="divider"
      style={{
        width: "64px",
        height: "6px",
        borderRadius: "10px",
        background: "linear-gradient(270deg, #13ADC7 0%, #945DD6 100% )",
      }}
    ></div>
  );
};

export default divider;
